import { withCompInfo } from '@wix/editor-elements-integrations'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'
import { PageGroupCssVars } from '@wix/thunderbolt-components-native'

const isStateBoxStateType = (type: string) => type === 'StateBoxState' || type === 'StateBoxFormState'

export const css = withCompInfo<PageGroupCssVars, any>()(
	[
		// @ts-ignore - Remove once originalComponentType is added to the compInfo
		'originalComponentType',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'compId',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],
	({
		// @ts-ignore - Remove once originalComponentType is added to the compInfo
		originalComponentType,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		const backgroundMedia = compDesign.background
		const cssVars = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compId,
			compDesign,
			compProps,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})

		return {
			isStateBoxStateType: isStateBoxStateType(originalComponentType),
			cssVars,
		}
	}
)
